import * as reducer from "./reducer";

export const reducers = {
    tenant: reducer.reducer
}

export * from "./actions"
export * from "./models"
